import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Calendar from '../../components/Planner/Calendar';

export default function CalendarSection() {
  const { project, projectId } = useOutletContext();
  const projIdForFilter = project?.id ?? project?.projectId ?? projectId ?? '';
  const fallback = project ? [{ ...project, id: projIdForFilter }] : [];

  return (
    <Calendar
      fallbackProjects={fallback}
      initialProjectFilter={String(projIdForFilter)}
      hideProjectSelector={true}
    />
  );
}
